import clsx from 'clsx';
import React from 'react';
import { DsmColor } from '../../constants/colors.mjs';
import { DsmRadius } from '../../constants/radii.mjs';
import { factory } from '../../factory/factory.utils.mjs';
import { Box } from '../../Other/Box/Box.mjs';
import classes from './Spinner.module.css.mjs';

const Spinner = factory((props, ref) => {
  const { className, ...rest } = props;
  const classNames = clsx("kohler-spinner-root", className);
  return /* @__PURE__ */ React.createElement(
    Box,
    {
      width: 40,
      height: 40,
      padding: 4,
      borderRadius: DsmRadius.Full,
      backgroundColor: DsmColor.SurfacePermaBlack,
      className: classNames,
      ref,
      ...rest
    },
    /* @__PURE__ */ React.createElement(Box, { width: 32, height: 32, borderRadius: DsmRadius.Full, className: classes.spinnerCircle })
  );
});

export { Spinner };
